export const pluralize = (
  singular: string,
  plural: string | undefined,
  count: number
) => {
  if (count === 0 || count > 1) return plural ?? `${singular}s`
  return singular
}
